import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import {
    addMessage,
    findMemberByEmail
} from '../../../api/apiServices';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import toast, { Toaster } from 'react-hot-toast'
import './Contact.css';

const Contact = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const [isMember, setIsMember] = useState(false)
    const [email, setEmail] = useState("")
    const [fullname, setFullname] = useState("")
    const [pf_number, setPfNumber] = useState("")
    const [mobile_number, setMobile] = useState("")
    const [message, setMessage] = useState("")

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/contact";

    const userRef = useRef();
    const errRef = useRef();

    const [errMsg, setErrMsg] = useState('');

    // useEffect(() => {
    //     userRef.current.focus();
    // }, [])

    useEffect(() => {
        setErrMsg('');
    }, [fullname, email, mobile_number, message, pf_number])



    const addMessageMutation = useMutation(addMessage, {
        onSuccess: () => {
            toast.success("Your message successfully submitted.", {
                duration: 3000,
                className: "toast-message"
            });
            setIsMember(false)
            setPfNumber("")
            setFullname("")
            setMobile("")
        }
    })

    const handleEmail = (e) => {
        e.preventDefault();
        const memberEmail = e.target.value;

        if (!memberEmail) {
            toast.error("Please enter your email address", {
                duration: 5000,
                className: "toast-message",
            });
            return false
        }
        else {
            findMemberByEmail(memberEmail).then((res) => {
                if (res.success) {
                    setIsMember(true)
                    let fullname = res.data.title + " " + res.data.first_name + " " + res.data.middle_name + " " + res.data.last_name
                    setPfNumber(res.data.pf_number)
                    setFullname(fullname)
                    setMobile(res.data.mobile_number)
                    userRef.current.focus();
                } else {
                    setIsMember(false)
                    setPfNumber("")
                    setFullname("")
                    setMobile("")
                }
            })
        }
    }


    const handlePhoneNumber = (mobile) => {
        if (!mobile) {
            toast.error("Please enter your mobile number",
                {
                    duration: 5000,
                    className: "toast-message",
                });
            return false
        } else if (mobile === "+233") {
            toast.error("The mobile number is not valid. Please provide a valid mobile number to continue",
                {
                    duration: 5000,
                    className: "toast-message",
                });
            return false;
        } else if (mobile.substring(4, 0) === '2330') {
            setMobile(mobile.replace('0', ''))
        } else {
            setMobile(mobile)
            return true
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const messageData = {
            fullname: fullname.toLocaleUpperCase(),
            email: email,
            mobile_number: mobile_number,
            message: message,
            pf_number: pf_number,
        }

        addMessageMutation.mutate(messageData)
        setFullname('');
        setMobile('');
        setEmail('');
        setMessage('');
        navigate(from, { replace: true });
    }

    const contactForm = (
        <>
            <fieldset>
                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            </fieldset>
            <form onSubmit={handleSubmit} >
                <div className="panel-body">
                    <div className="form-group row">
                        <label htmlFor="email" className="col-sm-3 col-form-label">Email Address<span>&nbsp;&nbsp;*</span></label>
                        <div className="col-sm-9">
                            <input
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                value={email}
                                onBlur={handleEmail}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="form-control"
                            />
                        </div>
                    </div>
                    {isMember ? (
                        <>
                            <div className="form-group row">
                                <label htmlFor="fullname" className="col-sm-3 col-form-label">Full Name<span>&nbsp;&nbsp;*</span></label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        name="fullname"
                                        style={{ textTransform: "capitalize" }}
                                        value={fullname}
                                        onChange={(e) => setFullname(e.target.value)}
                                        disabled
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="pf_number" className="col-sm-3 col-form-label">PF Number<span>&nbsp;&nbsp;*</span></label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        placeholder="PF Number"
                                        name="pf_number"
                                        style={{ textTransform: "uppercase" }}
                                        value={pf_number}
                                        onChange={(e) => setPfNumber(e.target.value)}
                                        disabled
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="mobile_number" className="col-sm-3 col-form-label">Mobile Number<span>&nbsp;&nbsp;*</span></label>
                                <div className="col-sm-9">
                                    <PhoneInput
                                        country={"gh"}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        value={mobile_number}
                                        inputStyle={{
                                            paddingTop: 16,
                                            paddingRight: 14,
                                            paddingBottom: 15,
                                            paddingLeft: 58,
                                            fontSize: 16,
                                            width: "100%",
                                            zIndex: 1,
                                            height: 40,
                                            backgroundColor: "#F3F6F9",
                                        }}
                                        disabled={true}
                                        onChange={(mobile_number) => setMobile(mobile_number)}
                                        required
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="form-group row">
                                <label htmlFor="fullname" className="col-sm-3 col-form-label">Full Name<span>&nbsp;&nbsp;*</span></label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        name="fullname"
                                        style={{ textTransform: "capitalize" }}
                                        value={fullname}
                                        onChange={(e) => setFullname(e.target.value)}
                                        required
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="mobile_number" className="col-sm-3 col-form-label">Mobile Number<span>&nbsp;&nbsp;*</span></label>
                                <div className="col-sm-9">
                                    <PhoneInput
                                        country={"gh"}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        value={mobile_number}
                                        inputStyle={{
                                            paddingTop: 16,
                                            paddingRight: 14,
                                            paddingBottom: 15,
                                            paddingLeft: 58,
                                            fontSize: 16,
                                            width: "100%",
                                            zIndex: 1,
                                            height: 40,
                                            backgroundColor: "#F3F6F9",
                                        }}
                                        onChange={(mobile_number) => handlePhoneNumber(mobile_number)}
                                        required
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="form-group row">
                        <label htmlFor="fullname" className="col-sm-3 col-form-label">Message<span>&nbsp;&nbsp;*</span></label>
                        <div className="col-sm-9">
                            <textarea
                                ref={userRef}
                                type="textarea"
                                name="message"
                                className="form-control"
                                placeholder="Type your message"
                                required
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                maxLength="1000"
                                cols="30"
                                rows="10" />
                        </div>
                    </div>
                </div>
                <div className="panel-footer">
                    <div className="form-group row">
                        <div className="col-sm-3">
                            <button type="submit" className="btn btn-success btn-block" >Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1><i className="fa fa-envelope"></i> Contact Us</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Send us a message</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <div className="contact-container">
                                    {contactForm}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;
